import { Typography } from "@/frontend/shared/ui/Typography";
import styles from "./OrganizeSection.module.scss";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { DropdownInput } from "@/frontend/shared/ui/DropdownInput";
import { useState } from "react";
import { options } from "./consts";
import { Input } from "@/frontend/shared/ui/Input";

export function OrganizeSection() {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState<string>("");
  return (
    <div className={styles.container}>
      <Typography variant="heading-6" color="greyscale900">
        Organize
      </Typography>
      <div className={styles.inputContainer}>
        <Typography variant="label-4" color="greyscale800">
          Stage
        </Typography>
        <DropdownInput
          options={options}
          onChange={(e) => setSelectedOption(e.target.value)}
          value={selectedOption}
          isOpen={isDropdownOpen}
          onClick={() => {
            setIsDropdownOpen((prev) => !prev);
          }}
          onSelect={(selected) => {
            setSelectedOption(selected);
            setIsDropdownOpen(false);
          }}
          onClose={() => setIsDropdownOpen(false)}
          rightCaretIcon={true}
          placeholder="Select pipeline"
        />
      </div>
      <div className={styles.inputContainer}>
        <Typography variant="label-4" color="greyscale800">
          Assign users
        </Typography>
        <Input placeholder="Email, comma separated" inputSize={"small"} value={selectedUsers} onChange={(e) => setSelectedUsers(e.target.value)} />
      </div>



      <div className={styles.bottomButtonsContainer}>
        <NormalButton size="large">Add Company</NormalButton>
        <NormalButton size="large" variant="secondary" color="greyscale800">
          Step back
        </NormalButton>
      </div>
    </div>
  );
}
